import { defineComponent as _defineComponent } from 'vue'
import { HeadingDisplayLoader } from '@/modules/trade/components/HeadingDisplayLoader';
import { ContentDisplayLoader } from '@/modules/trade/components/ContentDisplayLoader';
import { ListDisplayLoader } from '@/modules/trade/components/ListDisplayLoader';

export default /*#__PURE__*/_defineComponent({
  __name: 'PortabilityRequestsLoader',
  setup(__props) {


return { __sfc: true,HeadingDisplayLoader, ContentDisplayLoader, ListDisplayLoader }
}

})